export const district_data_government = {
    "type": "FeatureCollection",
    "features": [
        {
            "type": "Feature",
            "id": "node/2176870537",
            "properties": {
                "name": "Curriculum Development Center / editing and publishing",
                "office": "government",
                "toilets:wheelchair": "no",
                "wheelchair": "limited",
                "id": "node/2176870537"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3731796,
                    27.6851608
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/2176967325",
            "properties": {
                "name": "The Office of Controller of Examinations (OCE)",
                "office": "government",
                "operator": "Ministry of Education",
                "id": "node/2176967325"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3730921,
                    27.6839377
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4235736994",
            "properties": {
                "name": "Madhyapur Thimi Municipality",
                "office": "government",
                "id": "node/4235736994"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3896965,
                    27.6837543
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4243016526",
            "properties": {
                "name": "madhyapur thimi 15",
                "office": "government",
                "opening_hours": "10:00 - 17:00",
                "id": "node/4243016526"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3656923,
                    27.6747648
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4243040930",
            "properties": {
                "name": "VDC Office,12,13,14,15,16",
                "office": "government",
                "id": "node/4243040930"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4152053,
                    27.6926811
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4243043013",
            "properties": {
                "name": "NEA",
                "office": "government",
                "id": "node/4243043013"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3821266,
                    27.6752397
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4304550691",
            "properties": {
                "name": "Teacher Service Commotion",
                "office": "government",
                "toilets:wheelchair": "no",
                "wheelchair": "limited",
                "id": "node/4304550691"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3734759,
                    27.6860151
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4304621291",
            "properties": {
                "name": "Nepal Center For Educational Development Hostel",
                "office": "government",
                "id": "node/4304621291"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3719519,
                    27.6871596
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4304645990",
            "properties": {
                "name": "NCED branch",
                "office": "government",
                "id": "node/4304645990"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3726385,
                    27.6834589
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4304647489",
            "properties": {
                "name": "Nepal Center For Educational Development",
                "office": "government",
                "toilets:wheelchair": "no",
                "wheelchair": "yes",
                "id": "node/4304647489"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3717971,
                    27.6864247
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4341039697",
            "properties": {
                "name": "ERO Office",
                "office": "government",
                "id": "node/4341039697"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3724352,
                    27.6861099
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4341062892",
            "properties": {
                "name": "CDC",
                "office": "government",
                "id": "node/4341062892"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3730207,
                    27.6860129
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4356792494",
            "properties": {
                "addr:street": "byasi",
                "name": "District Education Office, Bhaktapur",
                "office": "government",
                "id": "node/4356792494"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4267367,
                    27.6789423
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4396457696",
            "properties": {
                "name": "Office of Controller of Examinations (OCE)",
                "office": "government",
                "id": "node/4396457696"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3768159,
                    27.6808675
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4476143994",
            "properties": {
                "addr:city": "Madhyapur Thimi Municipality",
                "addr:place": "Swanga Pukhu - 6",
                "addr:street": "Swanga Pukhu Marga",
                "amenity": "Public office",
                "name:en": "Madhyapur Thimi ward 6 Municipality Office",
                "office": "government",
                "opening_hours": "Su-Fr 10:00-04:00",
                "id": "node/4476143994"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3866649,
                    27.6818853
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4486629391",
            "properties": {
                "addr:street": "Bode,  Town Planning",
                "name:en": "Agriculture Training Center",
                "office": "government",
                "id": "node/4486629391"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.395864,
                    27.6902465
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4513012289",
            "properties": {
                "addr:housenumber": "2",
                "addr:street": "tumacho-barmayani",
                "name:en": "Bhaktapur malpot",
                "office": "government",
                "opening_hours": "Su-Fr",
                "id": "node/4513012289"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4412507,
                    27.6755072
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4560164502",
            "properties": {
                "name:en": "Nagarkot Municipality Office",
                "office": "government",
                "id": "node/4560164502"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4489785,
                    27.6819684
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4563715195",
            "properties": {
                "name:en": "Muktinath Workshop",
                "office": "government",
                "id": "node/4563715195"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3803423,
                    27.6732533
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4563726790",
            "properties": {
                "name:en": "B.R. Workshop",
                "office": "government",
                "id": "node/4563726790"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.38051,
                    27.6732835
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4563727392",
            "properties": {
                "name:en": "Asia Creation Nepal",
                "office": "government",
                "id": "node/4563727392"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3801131,
                    27.6737366
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4598092590",
            "properties": {
                "addr:street": "Lokanthali To Sano Thimi",
                "name:en": "District Forest Office, Bhaktapur",
                "office": "government",
                "opening_hours": "Su-Fr 10:00-17:00",
                "id": "node/4598092590"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.367829,
                    27.6836466
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4617878292",
            "properties": {
                "addr:postcode": "0977-016",
                "addr:street": "katunje bhaktapur",
                "name:en": "Department of roads katunje",
                "office": "government",
                "id": "node/4617878292"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4039791,
                    27.6675636
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4826551022",
            "properties": {
                "name:en": "Department of Transport Management (Renewal)",
                "office": "government",
                "id": "node/4826551022"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4052183,
                    27.6738497
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4826560421",
            "properties": {
                "name:en": "Department of transportation management ( Driving license)",
                "office": "government",
                "toilets:wheelchair": "no",
                "wheelchair": "yes",
                "id": "node/4826560421"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4364766,
                    27.6664342
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4870116021",
            "properties": {
                "name:en": "Municipality ward No.2",
                "office": "government",
                "id": "node/4870116021"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4278033,
                    27.6745799
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/5970742485",
            "properties": {
                "name:en": "DLPIU(District Level Project Implementation Unit)",
                "office": "government",
                "id": "node/5970742485"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4137285,
                    27.6757489
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/6002015507",
            "properties": {
                "name:en": "Tourist checkpoint - ticket counter",
                "office": "government",
                "id": "node/6002015507"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4318433,
                    27.6751581
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/6002015511",
            "properties": {
                "name:en": "Tourist Checkpoint - Ticket booth",
                "office": "government",
                "id": "node/6002015511"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4369313,
                    27.6760062
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/6002015512",
            "properties": {
                "name:en": "Tourist Checkpoint - ticket shop",
                "office": "government",
                "id": "node/6002015512"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4382963,
                    27.6733962
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/6002015513",
            "properties": {
                "name:en": "Tourist checkpoint - ticket shop",
                "office": "government",
                "id": "node/6002015513"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4242957,
                    27.6677302
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/6002021099",
            "properties": {
                "name:en": "Tourist checkpoint - ticket office",
                "office": "government",
                "id": "node/6002021099"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4231418,
                    27.6715403
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/6005408085",
            "properties": {
                "name:en": "Tourist ticket checkpoint",
                "office": "government",
                "id": "node/6005408085"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4317702,
                    27.6681389
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/6058283671",
            "properties": {
                "name": "National Youth Council",
                "office": "government",
                "toilets:wheelchair": "no",
                "wheelchair": "limited",
                "id": "node/6058283671"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3725245,
                    27.6823058
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/6058283672",
            "properties": {
                "name": "Education Review Office",
                "office": "government",
                "toilets:wheelchair": "no",
                "wheelchair": "no",
                "id": "node/6058283672"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.372166,
                    27.6856818
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/6058287188",
            "properties": {
                "name": "Teacher Service Commission",
                "office": "government",
                "toilets:wheelchair": "no",
                "wheelchair": "limited",
                "id": "node/6058287188"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3730715,
                    27.685537
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/6065309106",
            "properties": {
                "name": "Bhumishudar Office Bhaktapur Bashi",
                "office": "government",
                "toilets:wheelchair": "no",
                "wheelchair": "no",
                "id": "node/6065309106"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4289437,
                    27.6745111
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/6065309107",
            "properties": {
                "name": "Distance Education Office",
                "office": "government",
                "toilets:wheelchair": "limited",
                "wheelchair": "no",
                "id": "node/6065309107"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4272936,
                    27.674928
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/6065309108",
            "properties": {
                "name": "District Administration Office (CDO)-Bhaktapur",
                "office": "government",
                "toilets:wheelchair": "no",
                "wheelchair": "yes",
                "id": "node/6065309108"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4277341,
                    27.6741218
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/6065420353",
            "properties": {
                "name": "Nepal Telecom",
                "office": "government",
                "toilets:wheelchair": "no",
                "wheelchair": "yes",
                "id": "node/6065420353"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3758873,
                    27.6725285
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/6065482889",
            "properties": {
                "name": "Inland Revenue Department (Tax office Bhaktapur )",
                "office": "government",
                "toilets:wheelchair": "no",
                "wheelchair": "yes",
                "id": "node/6065482889"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4357643,
                    27.6660684
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/6375476469",
            "properties": {
                "addr:city": "Madhypur Thmi",
                "addr:postcode": "977",
                "addr:street": "Purano Thimi- Naya Thimi",
                "height": "10",
                "name": "Madhyapur thimi Ward 04",
                "office": "government",
                "id": "node/6375476469"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3852656,
                    27.6759823
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/6397585185",
            "properties": {
                "name:en": "sipadol woda karyalaya",
                "office": "government",
                "id": "node/6397585185"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4329768,
                    27.6436557
                ]
            }
        }
    ]
}
